import React from "react";
import { local_member_ui } from "../../../services/dtos";

interface MemberSearchDropdownProps {
  detailedJobRecords: any[] | null;
  selectedJob: any | null;
  alreadySubmitted: boolean;
  setMemberToAdd: React.Dispatch<React.SetStateAction<local_member_ui>>;
  memberToSearchFor: string;
  memberSearchResults: local_member_ui[];
  setMemberToSearchFor: React.Dispatch<React.SetStateAction<string>>;
  isSearchingForMember: boolean;
}

export const MemberSearchDropdown: React.FC<MemberSearchDropdownProps> = ({
  detailedJobRecords,
  selectedJob,
  alreadySubmitted,
  setMemberToAdd,
  memberToSearchFor,
  memberSearchResults,
  setMemberToSearchFor,
  isSearchingForMember,
}) => {
  const handleSearchMemberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (parseInt(e.target.value) < 3) {
      setMemberToAdd(null);
    }
    setMemberToSearchFor(e.target.value);
  };

  return (
    <>
      <div
        id="dropdownSearch"
        className="z-10 bg-white rounded-lg shadow w-60 dark:bg-gray-700"
      >
        <div className="p-3">
          <label htmlFor="input-group-search" className="sr-only">
            Search
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                 
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <div className="">
              <input
                type="text"
                id="input-group-search"
                className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Search user"
                disabled={
                  !detailedJobRecords ||
                  detailedJobRecords.length === 0 ||
                  !selectedJob ||
                  alreadySubmitted
                }
                value={memberToSearchFor}
                onChange={handleSearchMemberChange}
              />
            </div>
          </div>
          <div className="flex justify-center items-center mt-2">
            {isSearchingForMember && (
              <svg
                aria-hidden="true"
                className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            )}
          </div>
        </div>
        <ul
          className="h-48 px-3 pb-3 overflow-y-auto text-sm text-gray-700 dark:text-gray-200"
          aria-labelledby="dropdownSearchButton"
        >
          {memberSearchResults
            .filter(
              (member: local_member_ui) =>
              member.first_name + " " + member.last_name + " " + ( member.contact_email ?? "")
            )
            .map((member: local_member_ui) => (
              <li key={member.unique_member_id}>
                <div
                  onClick={() => setMemberToAdd(member)}
                  key={member.unique_member_id}
                  className="flex items-center pl-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  {
                    member.first_name + " " + member.last_name + " " + ( member.contact_email ?? "") }
                </div>
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};
